import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false,
})
export class AlertComponent implements OnChanges {
  @Input() type?: 'help' | 'info' | 'timer' | 'success' | 'warning' | 'danger';
  @Input() dismissable = false;
  @Input() bottomMargin = true;
  @Input() size?: 'small';

  alertClass: string | null = null;
  icon: string | null = null;

  show = true;

  ngOnChanges() {
    switch (this.type) {
      case 'help':
        this.alertClass = 'alert-secondary';
        this.icon = 'help-circle';
        break;
      case 'info':
        this.alertClass = 'alert-info';
        this.icon = 'info';
        break;
      case 'timer':
        this.alertClass = 'alert-info';
        this.icon = 'clock';
        break;
      case 'success':
        this.alertClass = 'alert-success';
        this.icon = 'check';
        break;
      case 'warning':
        this.alertClass = 'alert-warning';
        this.icon = 'alert-triangle';
        break;
      case 'danger':
        this.alertClass = 'alert-danger';
        this.icon = 'alert-circle';
        break;
      default:
        this.alertClass = null;
        this.icon = null;
        break;
    }

    switch (this.size) {
      case 'small':
        this.alertClass = (this.alertClass || '') + ' alert-sm';
        break;
    }
  }
}
